import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from './actions/auth.actions';
import { AuthCredentials } from '../models/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthActionsFacade {
  private readonly _store = inject(Store);

  public login(credentials: AuthCredentials): void {
    this._store.dispatch(AuthActions.login(credentials));
  }

  public logout(): void {
    this._store.dispatch(AuthActions.logout());
  }
}
